// Steps for homepage
const talentpoolSteps = [
{
    element: ".table",
    popover: {
        className: 'first-step-popover-class',
        title: "🙋<br>Let' start",
        description: '<b>This is your own database of interesting candidates </b> who caught your attention in the past but were rejected for some reason. Now you can easily contact them again! 👌',
        position: 'center',
        showButtons: true,
    },

},
{
    element: "#filter_with_job-talentpool",
    popover: {
        title: ' ',
        description: '<b>In the default state </b> you can see all candidates regardless of job.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".table",
    popover: {
        title: '🧑<br>Candidate overview stored in the talent pool ',
        description: 'You can add tags, experience, ★ ratings and your own notes to each candidate.',
        position: 'bottom',
        showButtons: true,
    },
    onNext: () => {
        setTimeout(function(){ $('#row-select-all').trigger('click'); }, 1000);

    }
},
{
    element: ".datatable-td",
    popover: {
        title: '🚀<br> Bulk action',
        description: '<b>Here you can select promising candidates.</b> Then you can choose "Send to Hiring" in the menu below and the selected candidates will appear among the current job seekers',
        position: 'right',
        showButtons: true,
    },
    onNext: () => {
        setTimeout(function(){ $('#row-select-all').trigger('click'); }, 1000);
        $('#onboarding.collapse').collapse('show');

    }


},
// {
//     element: ".align-self-start",
//     popover: {
// title: '🪄✨<br> Collective import of candidates',
//         description: 'A large number of candidates, e.g. from a recruitment agency, can be uploaded <b>from a spreadsheet (Excel or CSV).</b> If you already have your own database of candidates, you can upload it to your talent pool <b>with just one click</b> 🙂 ',
//         position: 'left-bottom',
//         showButtons: true,
//     },
//
// },


{
    element: "#sidebar",
    popover: {
        className: 'first-step-popover-class',
        title: 'Awesome!',
        description: 'Discover our functionalities that may help you with the onboarding <br>(4 min)<br>',
        position: 'right-center',
        showButtons: true,
        showButtons: true,         // Do not show control buttons in footer
        doneBtnText: 'Yes, carry on',
        nextBtnText: 'Understood',        // Next button text for this step
        prevBtnText: 'Back',
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/onboarding#guide");

    }
},
]



export default talentpoolSteps
